import * as React from 'react';
import { ColapsePanel } from '../core/ColapsePanel';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { SecurityData } from '../shared/index';
import { getAjaxhelper } from 'src/utils';
import { requestToken } from 'src/utils/request-token';
// import { getAjaxhelper } from 'src/utils';
export interface MyProfileProps extends BaseComponentProps {
    lang: string;
    user: SecurityData.ApplicationUser;
    user_login: boolean;
    userAccessChange: (type: string) => any;
}
export interface MyProfileState extends BaseComponentState {
    user: SecurityData.ApplicationUser;
    userLoginData: SecurityData.SecUserDetail | any;
    panelState: "EIDT" | "VIEW";
    token: string;
}

export class MyProfile extends BaseComponent<MyProfileProps, MyProfileState> {

    constructor(props: MyProfileProps) {
        super(props);
        this.state = {
            user: props.user,
            userLoginData: {},
            panelState: "VIEW",
            token: ""
        };
    }

    componentWillMount() {
        // this.setState({ user: this.props.user }); 
        // console.log(this.props.user);
        getAjaxhelper().post('/dynamics/bham-api/account-customer', { metode: 'get', data: this.props.user })
            .then(
                (d: any) => {
                    // console.log("User Dari Database", d);
                    if (d.user.uuid === this.props.user.uuid) {
                        let usr: SecurityData.SecUserDetail = d.user;
                        if (!usr.avatar_url) {
                            usr.avatar_url = this.props.user.image_url!;
                        }
                        for (let a of d.userRoleCodes!) {
                            if (a === 'SALES' || a === 'ADMIN') {
                                this.props.userAccessChange("SALES");
                                break;
                            }
                        }
                        this.setState({ user: this.props.user, userLoginData: usr });
                    } else {
                        this.setState({ user: this.props.user });
                    }
                })
            .catch(
                (exc: any) => {
                    alert('Error membaca login, error: ' + exc.message);
                });
    }

    formDetailAccount = () => {
        let comp = [];
        if (this.state.panelState === "EIDT") {
            comp.push(
                <form key='account-profile' className="form-horizontal">
                    <div className="form-group">
                        <label className="col-sm-2 control-label">  Name </label>
                        <div className="col-sm-10">
                            <input
                                type="text"
                                placeholder="Name"
                                className="form-control underline"
                                value={this.state.userLoginData.real_name}
                                onChange={(event) => {
                                    let x = event.target.value;
                                    this.setStateHelper(st => st.userLoginData.real_name = x);
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label"> Email  </label> 
                        <div className="col-sm-10">
                            <input
                                type="email"
                                placeholder="Email"
                                className="form-control underline"
                                value={this.state.userLoginData.email}
                                onChange={(event) => {
                                    let x = event.target.value;
                                    this.setStateHelper(st => st.userLoginData.email = x);
                                }}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label">
                            Address
                  </label>
                        <div className="col-sm-10">
                            <input 
                                type="text" 
                                placeholder="Address" 
                                className="form-control underline" 
                                value={this.state.userLoginData.address}
                                onChange={(event) => {
                                    let x = event.target.value;
                                    this.setStateHelper(st => st.userLoginData.address = x);
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label">
                            City
                  </label>
                        <div className="col-sm-10">
                            <input 
                                type="text" 
                                placeholder="City" 
                                className="form-control underline" 
                                value={this.state.userLoginData.city}
                                onChange={(event) => {
                                    let x = event.target.value;
                                    this.setStateHelper(st => st.userLoginData.city = x);
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label">
                            Province
                  </label>
                        <div className="col-sm-10">
                            <input 
                                type="text" 
                                placeholder="Province" 
                                className="form-control underline" 
                                value={this.state.userLoginData.province}
                                onChange={(event) => {
                                    let x = event.target.value;
                                    this.setStateHelper(st => st.userLoginData.province = x);
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label">
                            State
                  </label>
                        <div className="col-sm-10">
                            <input 
                                type="text" 
                                placeholder="State" 
                                className="form-control underline" 
                                value={this.state.userLoginData.state}
                                onChange={(event) => {
                                    let x = event.target.value;
                                    this.setStateHelper(st => st.userLoginData.state = x);
                                }}
                            />
                        </div>
                    </div>
                     
                    <div className="form-group">
                        <label className="col-sm-2 control-label">
                            Post Code
                  </label>
                        <div className="col-sm-10">
                            <input 
                                type="text" 
                                placeholder="Post Code" 
                                className="form-control underline" 
                                value={this.state.userLoginData.postCode}
                                onChange={(event) => {
                                    let x = event.target.value;
                                    this.setStateHelper(st => st.userLoginData.postCode = x);
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label">
                            Phone Number
                  </label>
                        <div className="col-sm-10">
                            <input 
                                type="text" 
                                placeholder="Post Code" 
                                className="form-control underline" 
                                value={this.state.userLoginData.phone1}
                                onChange={(event) => {
                                    let x = event.target.value;
                                    this.setStateHelper(st => st.userLoginData.phone1 = x);
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label" />
                        <div className="col-sm-10">
                            <input 
                                type="button" 
                                placeholder="Post Code" 
                                className="btn btn-primary" 
                                value="Save" 
                                onClick={
                                    () => {
                                        let data = this.state.userLoginData; 
                                        getAjaxhelper().put(`/dynamics/bham-api/account-customer`, { data: data, token: this.state.token }).then(
                                            d => {
                                                console.log(d);
                                                this.setState({userLoginData: d.user, panelState: "VIEW"});
                                            }
                                        ).catch(
                                            err => {
                                                console.log(err);
                                            }
                                        );
                                    }
                                }
                            />
                        </div>
                    </div>
                </form>

            );
        } else {
            comp.push(
                <form key='account-profile' className="form-horizontal">
                    <div className="form-group">
                        <label className="col-sm-2 control-label" >  Name </label>
                        <div className="col-sm-10">
                            <label   style={{lineHeight: '30px'}} > {this.state.userLoginData.real_name} </label>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label"> Email  </label> 
                        <div className="col-sm-10">
                        <label  style={{lineHeight: '30px'}}  > {this.state.userLoginData.email} </label>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label">  Address </label>
                        <div className="col-sm-10">
                        <label  style={{lineHeight: '30px'}}  > {this.state.userLoginData.address ? this.state.userLoginData.address : '...'} </label>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label">  City </label>
                        <div className="col-sm-10">
                        <label  style={{lineHeight: '30px'}}  > {this.state.userLoginData.city ? this.state.userLoginData.city : '...'} </label>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label">  Province </label>
                        <div className="col-sm-10">
                        <label style={{lineHeight: '30px'}} > {this.state.userLoginData.province ? this.state.userLoginData.province : '...'} </label>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label"> State </label>
                        <div className="col-sm-10">
                        <label  style={{lineHeight: '30px'}}  > {this.state.userLoginData.state ? this.state.userLoginData.state : '...'} </label>
                        </div>
                    </div> 
                    <div className="form-group">
                        <label className="col-sm-2 control-label">  Post Code </label>
                        <div className="col-sm-10">
                        <label  style={{lineHeight: '30px'}}  > {this.state.userLoginData.postCode ? this.state.userLoginData.postCode : '...'} </label>
                        </div>
                    </div>
                   
                    <div className="form-group">
                        <label className="col-sm-2 control-label">  Phone Number </label>
                        <div className="col-sm-10">
                        <label  style={{lineHeight: '30px'}}  > {this.state.userLoginData.phone1 ? this.state.userLoginData.phone1 : '...'} </label>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-2 control-label" />
                        <div className="col-sm-10">
                            <input 
                                type="button" 
                                className="btn btn-primary" 
                                value="Edit Data" 
                                onClick={
                                    () => {
                                        requestToken().then(d => {
                                            this.setState({ token: d, panelState: "EIDT" });
                                        }).catch(exc => {
                                            console.log(exc);
                                        });
                                    }
                                }
                            />
                        </div>
                    </div>
                </form>
            );
        }

        return comp;
    } 
    formSosmed = () => {
        let comp = [];
        comp.push(<h1 key='a'>Sosmed detail</h1>);
        return comp;
    }
    formId = () => {
        let comp = [];
        comp.push(<h1 key='a'>ID</h1>);

        return comp;
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        return (
            <div style={{ minHeight: 500 }}>

                <div style={{ width: '100%', float: 'left' }} >
                    <ColapsePanel key='detail' title="Your information detail" component={this.formDetailAccount()} colapse={true} />

                </div>
            </div>
        );
    }
} 


// WEBPACK FOOTER //
// ./src/my-account/MyProfile.tsx